export default __webpack_public_path__ + "static/media/FranklinGothicMedium.8c9674fc.ttf";